<template>
  <div class="c-app">
    <Sidebar :key="locale" />
    <CWrapper>
      <Header />
      <div class="c-body">
        <main class="c-main">
          <div>
            <transition name="fade">
              <router-view />
            </transition>
          </div>
        </main>
        <Footer />
        <UserLoading v-if="loading" />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "../commons/Sidebar";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import UserLoading from "../commons/Loading";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AuthLayout",
  metaInfo() {
    return {
      title: "",
      titleTemplate: "株式会社 Fabbi"
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    UserLoading
  },

  computed: {
    ...mapState("layout", {
      loading: state => state.loading
    }),
    ...mapGetters({
      existsProjectManagement: "projectManagement/existsProjectManagement"
    }),
    locale: function() {
      return this.$i18n.locale;
    }
  },

  async created() {
    await this.$store.dispatch("projectManagement/getExistsProjectManagement");
    if (
      this.$route.path.includes("/project-management") &&
      !this.existsProjectManagement
    ) {
      this.$router.push({ name: "403" });
    }
  }
};
</script>

<style lang="scss" scoped>
.c-main {
  background: #f5f5f5;
}
@media screen and (max-width: 740px) {
  .c-main {
    padding-top: 0 !important;
  }
}
</style>
